module.exports = __webpack_public_path__ + "static/media/login-image.94b53ea6.gif";